import axios from "axios";

import { buildContactExportCsv } from "./contactExportCsv.mjs";

export const createContactBulkExportState = () => ({
  selectedContactIds: [],
  bulkExportLoading: false,
});

export const contactBulkExportComputed = {
  selectedContactCount() {
    return Array.isArray(this.selectedContactIds) ? this.selectedContactIds.length : 0;
  },
};

export const contactBulkExportMethods = {
  async handleCompaniesConverted(results) {
    const count = results.filter((row) => row.person_id).length;
    if (count === results.length) {
      this.snackbar.message = this.$t("ncrm.contacts.conversion.result", { count, total: results.length });
      this.snackbar.show = true;
    }
    await this.fetchContacts();
  },
  isSelectionClick(event) {
    if (!event?.target || typeof event.target.closest !== "function") return false;
    return Boolean(
      event.target.closest(".v-selection-control") ||
        event.target.closest(".v-data-table__checkbox")
    );
  },
  retainVisibleContactSelection() {
    const visibleIds = new Set(this.filteredItems.map((item) => Number(item?.id)).filter(Boolean));
    this.selectedContactIds = (this.selectedContactIds || []).filter((id) =>
      visibleIds.has(Number(id))
    );
  },
  clearSelectedContacts() {
    this.selectedContactIds = [];
  },
  async handleBulkDownloadSelected() {
    const selectedIds = (this.selectedContactIds || []).map((id) => Number(id)).filter(Boolean);
    if (!selectedIds.length || this.bulkExportLoading) return;
    this.bulkExportLoading = true;
    try {
      const records = await this.fetchSelectedContactDetails(selectedIds);
      const { csv, columns } = buildContactExportCsv({
        type: this.activeType,
        records,
        translate: (key) => this.$t(key),
      });
      if (!columns.length) {
        this.snackbar.message = this.$t("ncrm.contacts.selection.noFields");
        this.snackbar.show = true;
        return;
      }
      this.downloadCsv(csv, this.buildBulkExportFilename());
      this.snackbar.message = this.$t("ncrm.contacts.selection.downloaded", {
        count: records.length,
      });
      this.snackbar.show = true;
    } catch (error) {
      console.error("[ncrm] export selected contacts failed:", error);
      this.snackbar.message =
        error?.response?.data?.error || this.$t("ncrm.contacts.selection.downloadError");
      this.snackbar.show = true;
    } finally {
      this.bulkExportLoading = false;
    }
  },
  async fetchSelectedContactDetails(selectedIds) {
    const endpointBase = this.activeType === "company" ? "/ncrm/companies" : "/ncrm/people";
    const responses = await Promise.all(selectedIds.map((id) => axios.get(`${endpointBase}/${id}`)));
    return responses.map((response) => response?.data || {});
  },
  buildBulkExportFilename() {
    const date = new Date();
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const type = this.activeType === "company" ? "companies" : "people";
    return `crm-${type}-export-${yyyy}-${mm}-${dd}.csv`;
  },
  downloadCsv(csv, filename) {
    const blob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },
};

export const contactBulkExportMixin = {
  data: createContactBulkExportState,
  computed: contactBulkExportComputed,
  methods: contactBulkExportMethods,
};
